.create {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

